'use client'

import { Button, ButtonProps, ButtonVariants } from '../..'
import { ArrowLeftIcon } from '../../../icons'
import {
    ICON_BUTTON_ARIA_LABEL_MESSAGE_KEYS,
    resolveIconButtonAriaLabel,
} from '../../../../constants/iconButtonAriaLabelMessageKeys'
import { DictionaryContext } from '../../../../providers'
import React, { FC, ReactElement, useContext } from 'react'
import { LinkAsButton } from '../../Link/LinkAsButton'

interface BackButtonProps extends Omit<ButtonProps, 'variant' | 'icon'> {}

export const BackButton: FC<BackButtonProps> = ({
    children,
    href,
    'aria-label': ariaLabelProp,
    ...rest
}): ReactElement => {
    const dictionary = useContext(DictionaryContext)
    const ariaLabel =
        ariaLabelProp ??
        (!children
            ? resolveIconButtonAriaLabel(dictionary, ICON_BUTTON_ARIA_LABEL_MESSAGE_KEYS.NAVIGATE_BACK)
            : undefined)

    if (href) {
        return (
            <LinkAsButton
                data-testid="back-button"
                variant={ButtonVariants.QUIET}
                icon={<ArrowLeftIcon />}
                {...rest}
                href={href}
                aria-label={ariaLabel}
            >
                {children}
            </LinkAsButton>
        )
    }

    return (
        <Button
            data-testid="back-button"
            variant={ButtonVariants.QUIET}
            icon={<ArrowLeftIcon />}
            {...rest}
            aria-label={ariaLabel}
        >
            {children}
        </Button>
    )
}
